import { gql }  from '@apollo/client';

const SHOW_INSURANCE_NETWORKS = gql`
  query($sortingParams: SortingInput) {
    insuranceNetworks(sortingParams: $sortingParams) {
      id
      name
    }
  }
`;

export default SHOW_INSURANCE_NETWORKS;
